const getSummary = function (state) {
  return {...state.summary}
}

const getItinerario = function (state) {
  return {...state}
}

const getTour = function (state) {
  return state.tour
}

export default {
  getSummary,
  getItinerario,
  getTour
}



// WEBPACK FOOTER //
// ./src/front/store/modules/itinerario/getters/itinerario.js